import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "queryMessage", "defaultEmpty"]

  filter() {
    const query = this.inputTarget.value.trim().toLocaleLowerCase()
    let visibleCount = 0

    this.itemTargets.forEach((item) => {
      const visible = item.dataset.searchValue.toLocaleLowerCase().includes(query)
      item.hidden = !visible
      visibleCount += visible ? 1 : 0
    })

    this.defaultEmptyTargets.forEach((message) => {
      message.hidden = query.length > 0
    })
    this.queryMessageTarget.hidden = query.length === 0 || visibleCount > 0
  }
}
